export enum CatalogStatus {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  LOADING = 'LOADING',
  INITIALIZED = 'INITIALIZED',
  ERROR = 'ERROR'
}
